import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  success: false,
  filters: {},
  appliedFilters: {},
  filtersPayload: Constants.SCORECARD_FILTER_DRAWER.FILTERS_PAYLOAD,
  updateLoading: false,
  updateError: false,
  updateScuccess: false,
};

export const scorecardFiltersSlice = createSlice({
  name: "scorecardFilters",
  initialState,
  reducers: {
    getScorecardFiltersStart: (state) => ({
      ...state,
      loading: true,
      error: false,
      success: false,
      updateError: false,
      updateScuccess: false,
      filters: [],
    }),
    getScorecardFiltersSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      success: true,
      filters: action.payload || {},
    }),
    getScorecardFiltersFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
      success: false,
    }),
    updateScorecardFiltersStart: (state) => ({
      ...state,
      updateLoading: true,
      updateError: false,
      updateScuccess: false,
      error: false,
      success: false,
    }),
    updateScorecardFiltersSuccess: (state, action) => ({
      ...state,
      updateLoading: false,
      updateError: false,
      updateScuccess: true,
      filters: action.payload || {},
    }),
    updateScorecardFiltersFailure: (state) => ({
      ...state,
      updateLoading: false,
      updateError: true,
      updateScuccess: false,
    }),
    updateAppliedFilters: (state) => ({
      ...state,
      appliedFilters: state.filters || {},
    }),
    updateFiltersPayload: (state, action) => ({
      ...state,
      filtersPayload: action.payload,
    }),
    resetScorecardFilters: () => ({
      ...initialState,
    })
  },
});

export const {
  getScorecardFiltersStart,
  getScorecardFiltersSuccess,
  getScorecardFiltersFailure,
  updateScorecardFiltersStart,
  updateScorecardFiltersSuccess,
  updateScorecardFiltersFailure,
  updateAppliedFilters,
  updateFiltersPayload,
  resetScorecardFilters,
} = scorecardFiltersSlice.actions;

export const updatedFiltersPayloadOnFiltersChange = (
  currFiltersPayload, updatedFilters, dispatch
) => {
  const updatedFilterPayload = currFiltersPayload.map(filterObj => {
    const selectedFilters = updatedFilters[filterObj.label]
      .filter(option => option.isSelected)
      .map(option => option.value);

    return {
      ...filterObj,
      filterValues: filterObj.filterValues.filter(value => selectedFilters.includes(value))
    };
  });
  dispatch(updateFiltersPayload(updatedFilterPayload));
}

export const getScorecardFilters = (payload, scorecardId) => (dispatch) => {
  dispatch(getScorecardFiltersStart());

apiService.post(
  `${Constants.API.SCORE_CARD}/${scorecardId}${Constants.API.SCORE_CARD_FILTER}`
, payload).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        const updatedFilters = data?.data;
        updatedFiltersPayloadOnFiltersChange(payload, updatedFilters, dispatch);
        dispatch(getScorecardFiltersSuccess(updatedFilters));
      } else {
        dispatch(getScorecardFiltersFailure());
      }
    } else {
      dispatch(getScorecardFiltersFailure());
    }
  }).catch(() => {
    dispatch(getScorecardFiltersFailure());
  }) 
};

export const updateScorecardFilters = (payload, scorecardId) => (dispatch) => {
  dispatch(updateScorecardFiltersStart());

  apiService.post(
    `${Constants.API.SCORE_CARD}/${scorecardId}${Constants.API.SCORE_CARD_FILTER}`
  , payload).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        const updatedFilters = data?.data;
        updatedFiltersPayloadOnFiltersChange(payload, updatedFilters, dispatch);
        dispatch(updateScorecardFiltersSuccess(updatedFilters));
      } else {
        dispatch(updateScorecardFiltersFailure());
      }
    } else {
      dispatch(updateScorecardFiltersFailure());
    }
  }).catch(() => {
    dispatch(updateScorecardFiltersFailure());
  }) 
};

export default scorecardFiltersSlice.reducer;
